export function maskCPF(value = '') {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
}

export function maskCNPJ(value = '') {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
}

export function maskCPForCNPJ(value = '') {
  const clear = value.toString().replace(/\D/g, '');
  if (clear.length <= 11) {
    return maskCPF(value);
  }

  return maskCNPJ(value);
}

export function maskDate(value = '') {
  const stringValue = value.toString();

  const masked = stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1');

  const [d, m, y] = masked.split('/');

  let modDay = d;
  let modMonth = m;
  let modYear = y;

  if (!!d && d.length > 0) {
    if (Number.parseInt(d) > 31) {
      modDay = '31';
    }

    if (d.length >= 2) {
      if (Number.parseInt(d) === 0) {
        modDay = '01';
      }
    }
  }

  if (!!m && m.length > 0) {
    if (Number.parseInt(m) > 12) {
      modMonth = '12';
    }

    if (m.length >= 2) {
      if (Number.parseInt(m) === 0) {
        modMonth = '01';
      }
    }
  }

  return [modDay, modMonth, modYear].filter(Boolean).join('/');
}

export function maskCellPhone(value = '') {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
}

export function maskFullName(value = '') {
  const stringValue = value.toString();
  return stringValue
    .replace(/[^a-zA-Z\s]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (match) => match.toUpperCase());
}

export function maskTextAndNumbers(value = '') {
  const stringValue = value.toString();
  return stringValue.replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, ' ');
}

export function maskEmail(value = '') {
  return value.trim().replace(/[^a-zA-Z0-9._@-]/g, '');
}

export function maskPostalCode(value = '') {
  const stringValue = value.toString();
  return stringValue
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');
}

export function maskMoney(value = '') {
  const stringValue = value.toString();
  if (!stringValue) return '';
  const numericValue = Number(stringValue.replace(/\D/g, ''));
  if (isNaN(numericValue) || !isFinite(numericValue)) return '';
  const formatted = Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue / 100);

  return formatted;
}

export function unmaskNumber(value = '') {
  return value.toString().replace(/\D/g, '');
}

export function unmaskString(value = '') {
  return value.toString().replace(/[^a-zA-Z0-9]/g, '');
}

export function unmaskMoney(value = '') {
  const [val, cents] = value.replace('R$', '').trim().split(',');

  const numericVal = Number(val.replace(/\./g, ''));
  const numericCents = Number(cents || '0');

  if (Number.isNaN(numericVal) || Number.isNaN(numericCents)) {
    return 0;
  }

  if (numericVal === 0 && numericCents === 0) {
    return 0;
  }

  return numericVal * 100 + Math.min(99, numericCents);
}

export function maskAgency(value = '') {
  const stringValue = value.toString();
  return stringValue.replace(/\D/g, '').slice(0, 4);
}

export function maskAccount(value = '') {
  const stringValue = value.toString();
  return stringValue.replace(/\D/g, '').slice(0, 9);
}
